import {useQueries} from "@tanstack/react-query";
import individualService from "../../../../../services/web/individual-service.js";
import natureService from "../../../../../services/web/nature-service.js";

const useFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['bodyShape'],
                queryFn: () => individualService.bodyShape(),
            },
            {
                queryKey: ['colorEyes'],
                queryFn: () => individualService.colorEyes(),
            },
            {
                queryKey: ['hairType'],
                queryFn: () => individualService.hairType(),
            },
            {
                queryKey: ['hairColor'],
                queryFn: () => individualService.hairColor(),
            },
            {
                queryKey: ['hairSize'],
                queryFn: () => individualService.hairSize(),
            },
            {
                queryKey: ['situations'],
                queryFn: () => individualService.situations(),
            },
            {
                queryKey: ['individualColors'],
                queryFn: () => individualService.individualColors(),
            },
            {
                queryKey: ['region'],
                queryFn: () => individualService.region(),
            },
            {
                queryKey: ['regionDetail'],
                queryFn: () => individualService.regionDetail(),
            },
            {
                queryKey: ['instructions'],
                queryFn: () => individualService.individualInstructions(),
            },
            {
                queryKey: ['system_natures'],
                queryFn: () => natureService.getSystemNatures(),
                initialData: []
            },
        ]
    });

    return {
        bodyShape: queries[0].data,
        colorEyes: queries[1].data,
        hairType: queries[2].data,
        hairColor: queries[3].data,
        hairSize: queries[4].data,
        situations: queries[5].data,
        individualColors: queries[6].data,
        region: queries[7].data,
        regionDetail: queries[8].data,
        instructions: queries[9].data,
        systemNatures: queries[10].data,
    }
};

export default useFetchData;
